export const notHasPermissions = navigate => {
  alert('No cuenta con permisos para acceder');
  navigate('/');
};
